import React, { useRef, useState } from 'react'
import { OutsideClickHandler } from '../../utils/OutsideClickHandler'
import styles from '../styles.module.scss'

export type BarDropdownProps = {
  dropDownClassName?: string
  icon: JSX.Element
  isContentAvailable?: boolean
  onVisibleChange?: (isVisible: boolean) => void
  children: JSX.Element
  dataTestId: string
  [props: string]: any
}

function setIsOpen(
  isOpen: boolean,
  setDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>,
  onVisibleChange: ((isVisible: boolean) => void) | undefined
) {
  setDropdownOpen(isOpen)
  if (onVisibleChange !== undefined) {
    onVisibleChange(isOpen)
  }
}

export const BarDropdown = ({
  icon,
  dropDownClassName,
  isContentAvailable,
  onVisibleChange,
  children,
  dataTestId
}: BarDropdownProps) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const iconRef = useRef(null)

  return (
    <React.Fragment>
      <div
        className={`${styles.iconWrapper} ${isDropdownOpen ? styles.active : ''}`}
        ref={iconRef}
        onClick={() =>
          setIsOpen(!isDropdownOpen, setDropdownOpen, onVisibleChange)
        }
        data-testid={dataTestId}
      >
        {icon}
      </div>
      {isDropdownOpen &&
      (isContentAvailable === true || isContentAvailable === undefined) ? (
        <OutsideClickHandler
          className={`${styles.supportBarRightPanel} ${
            dropDownClassName || ''
          }`}
          ignoreRefs={[iconRef]}
          onOutsideClick={() =>
            setIsOpen(false, setDropdownOpen, onVisibleChange)
          }
        >
          {children}
        </OutsideClickHandler>
      ) : null}
    </React.Fragment>
  )
}
